












import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { ServerResult } from '@/core/http/server_result';
import { QueryBuilder } from '@/core/uql';

@Component
export default class RelationComponent extends Vue {
  $db!: (queries: any[]) => Promise<ServerResult>
  $q!: (queryName: string) => QueryBuilder;

  @Prop() value!: any;
  @Prop({ type: String }) label!: string;
  @Prop({ type: String }) type!: any[];
  @Prop({ type: String }) placeholder!: string;
  @Prop({ type: Object }) fieldSchema!: any;

  localValue: any = null

  get schemaName() {
    return this.fieldSchema.meta.related_schema_id.split(':')[1]
  }

  @Watch('value')
  onValueChange(newVal: any) {
    this.localValue = newVal;
  }

  updateValue(value: any) {
    this.onValueChange(value);

    this.$emit('input', value);
  }
}
